@if (showModalHeader) {
  <div>
    <h1 class="title">{{ documentName || 'View Document' }}</h1>
    <button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>
  </div>
}

@if (documentURL) {
  <div>
    <ngx-extended-pdf-viewer
      [src]="documentURL"
      [authorization]="true"
      backgroundColor="#F7F7F7"
      [showToolbar]="true"
      [showSidebarButton]="false"
      [showFindButton]="false"
      [showPagingButtons]="false"
      [showDrawEditor]="false"
      [showTextEditor]="false"
      [showZoomButtons]="showZoomButton"
      [showPresentationModeButton]="false"
      [showOpenFileButton]="false"
      [showPrintButton]="showPrintButton"
      [showDownloadButton]="showDownloadButton"
      [showSecondaryToolbarButton]="true"
      [showHandToolButton]="false"
      [showScrollingButtons]="false"
      [showSpreadButton]="false"
      [showPropertiesButton]="false"
      [showRotateButton]="false"
      [height]="containerHeight"
      [textLayer]="false"
    >
    </ngx-extended-pdf-viewer>
  </div>
}
